<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="mb-lg">
            <div class="card" v-if="!isLoading">
              <argon-alert v-if="showAlert" color="danger">
                <strong>Alerta!</strong> Existen campos vacios que son
                obligatorios!
              </argon-alert>
              <argon-alert
                v-if="showSuccess"
                color="success"
                :dismissible="true"
              >
                <strong>Completado!</strong> Campos guardados correctamente!
              </argon-alert>
              <div class="card-header pb-0">
                <div class="d-flex align-items-center">
                  <h4 class="mb-0">Libramiento</h4>
                </div>
              </div>
              <div class="card-body">
                <p class="text-uppercase text-sm">META</p>
                <hr class="horizontal dark" />
                <div class="row">
                  <div class="col-md-12">
                    <label for="example-text-input" class="form-control-label"
                      >Nombre</label
                    >
                    <argon-input
                      v-model="bypass.name"
                      @valid="absoluteValidation($event)"
                      :isRequired="true"
                      id="0"
                      name="Nombre"
                    />
                  </div>
                  <div class="col-md-12">
                    <label for="example-text-input" class="form-control-label"
                      >Nombre completa</label
                    >
                    <argon-input
                      v-model="bypass.geofence"
                      @valid="absoluteValidation($event)"
                      :isRequired="true"
                      id="1"
                      name="Nombre completa"
                    />
                  </div>
                  <div class="col-md-12">
                    <label for="example-text-input" class="form-control-label"
                      >Kilometros</label
                    >
                    <argon-input
                      v-model="bypass.services"
                      @valid="absoluteValidation($event)"
                      :isRequired="true"
                      id="2"
                      name="Kilometros"
                    />
                  </div>
                  <div class="col-md-12">
                    <label for="example-text-input" class="form-control-label"
                      >Sitios de interés</label
                    >
                    <argon-input
                      v-model="bypass.interest_sites"
                      @valid="absoluteValidation($event)"
                      :isRequired="true"
                      id="3"
                      name="Sitios de interés"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <argon-button
                      color="primary"
                      size="lg"
                      class="ms-auto"
                      @click-callback="finalValidation"
                      :fullWidth="true"
                      >Guardar</argon-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";

export default {
  name: "bypass-card",
  props: {
    bypassID: { type: String, required: true },
  },
  data() {
    return {
      isLoading: true,
      showAlert: false,
      showSuccess: false,
      valid: Array(4).fill(true),
      bypassIDLocal: this.bypassID,
      bypass: {
        name: "",
        geofence: "1",
        services: "",
        interest_sites: "",
      },
    };
  },
  components: { ArgonInput, ArgonButton, ArgonAlert },
  created() {
    // // console.log("BYPASS BYPASS BYPASS");
    // // console.log(this.bypassIDLocal);
    if (this.bypassIDLocal !== '0') {
      this.plain
        .get(`/bypasses/${this.bypassIDLocal}`)
        .then((response) => {
          delete response.data.id;
          delete response.data.created_at;
          delete response.data.updated_at;
          this.bypass = response.data;
          this.isLoading = false;
          // // console.log("RESPONSE");
          // // console.log(this.bypass);
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(err);
        });
    } else {
      this.bypassIDLocal = undefined;
      this.isLoading = false;
    }
  },
  methods: {
    absoluteValidation(event) {
      this.showAlert = false;
      this.showSuccess = false;
      this.valid[event.inputIndex] = event.valid;
    },
    finalValidation() {
      if (this.valid.includes(false)) {
        this.showAlert = true;
        window.scrollTo(0, 0);
      } else {
        if (this.bypassIDLocal !== undefined) this.editBypass();
        else this.createBypass();
      }
    },
    createBypass() {
      this.plain
        .post("/bypasses", this.bypass)
        .then((response) => {
          // console.log("LIBRAMIENTO creado correctamente");
          // console.log(response.data);
          window.scrollTo(0, 0);
          this.showSuccess = true;
          this.bypassIDLocal = response.data.id; //SOLUCIONAR PROBLEMA DE ALERTAS AQUI ES CON LA NAVEGACION route y con una variable local
          delete response.data.id;
          delete response.data.created_at;
          delete response.data.updated_at;
          this.bypass = response.data;
        })
        .catch((error) => {
          console.log("Error al crear LIBRAMIENTOS", error);
        });
    },
    editBypass() {
      this.plain
        .patch(`/bypasses/${this.bypassIDLocal}`, this.bypass)
        .then((response) => {
          // console.log("LIBRAMIENTO editado correctamente");
          // console.log(response.data);
          window.scrollTo(0, 0);
          this.showSuccess = true;
          //this.bypassID = response.data.id;
          delete response.data.id;
          delete response.data.created_at;
          delete response.data.updated_at;
          this.bypass = response.data;
          // console.log("EDIT");
          // console.log(this.bypass);
        })
        .catch((error) => {
          console.log("Error al editar LIBRAMIENTOS", error);
        });
    },
  },
};
</script>